// extracted by mini-css-extract-plugin
export default {"Sides":"Sides_Sides__XNERm"};